"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLoginSectionContent = exports.StyledLoginSectionTitle = exports.StyledLoginSectionLinkButton = exports.StyledLoginSectionAlternativeButton = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const controls_1 = require("../controls");
const helpers_1 = require("../helpers");
const layouts_1 = require("../layouts");
const StackView_1 = require("../StackView");
const Text_1 = require("../Text");
const icons_1 = require("./icons");
exports.StyledLoginSectionAlternativeButton = (0, styled_components_1.default)(layouts_1.SplashScreenAlternativeButton) `
    min-width: 264px;

    ${({ disabled, theme }) => (0, styled_components_1.css) `
        ${icons_1.FigureUser}, ${icons_1.FigureKey} {
            fill: ${disabled ? '#fff' : theme.colorTextRestButton};
        }
    `}
`;
exports.StyledLoginSectionLinkButton = (0, styled_components_1.default)(controls_1.LinkButton) `
    margin-top: ${helpers_1.SPACING_S};
`;
exports.StyledLoginSectionTitle = (0, styled_components_1.default)(Text_1.Text) `
    height: ${helpers_1.SIZE_XL};
    line-height: ${helpers_1.SIZE_XL};
`;
exports.StyledLoginSectionContent = (0, styled_components_1.default)(StackView_1.StackView) `
    width: 320px;
`;
//# sourceMappingURL=LoginSection.styles.js.map